document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-dbmv]').forEach(section => {
        const swiperEl = section.querySelector('.dbmv-swiper');
        if (!swiperEl || typeof Swiper === 'undefined') return;

        const swiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            loop: true,
            speed: 700,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            preloadImages: false,
            lazy: {
                loadPrevNext: true
            }
        });

        /* Play / Pause video only when visible */
        const videos = section.querySelectorAll('video');

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    const video = entry.target;
                    if (entry.isIntersecting) {
                        video.play().catch(() => { });
                    } else {
                        video.pause();
                    }
                });
            }, { threshold: 0.4 });

            videos.forEach(video => observer.observe(video));
        } else {
            videos.forEach(video => video.play().catch(() => { }));
        }
    });

});
